module.exports = __webpack_public_path__ + "static/media/beauty.a8c337e8.svg";